package com.anjuros.website.templates.template4.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template4.modules.Template4Review
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColor
import com.anjuros.website.templates.template4.styles.Template4ProjectReviewStyle
import com.anjuros.website.templates.template4.util.Template4Constants
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template4TestimonialCard(template4Review: Template4Review){


    Box(modifier = Template4ProjectReviewStyle
        .toModifier()
        .backgroundColor(Colors.White)
        .margin(20.px)
        .borderRadius(
        topLeft = 20.px, topRight = 0.px, bottomLeft = 0.px, bottomRight = 20.px
    ).boxShadow(
        2.px,2.px,10.0.px,1.0.px, color = Template4Theme.Primary.getColor(),false
    )){
        Column(modifier = Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .align(Alignment.Center)
            .id("reviewColumn"),
            horizontalAlignment = Alignment.CenterHorizontally) {
            Box(modifier = Modifier.fillMaxWidth().borderRadius(topLeft = 20.px).backgroundColor(Template4Theme.Primary.getColor())) {
                P(
                    attrs = Modifier
                        .align(Alignment.Center)
                        .margin(topBottom = 3.px)
                        .fontFamily(Template4Constants.FONT_FAMILY)
                        .fontSize(20.px)
                        .fontWeight(FontWeight.Normal)
                        .color(Colors.White)
                        .toAttrs()
                ) {
                    Text(LocalText(template4Review.title))

                }
            }
            Box(modifier = Modifier
                .id("reviewBox").fillMaxWidth(90.percent).fillMaxHeight()) {
                P(
                    attrs = Modifier
                        .id("reviewText")
                        .align(Alignment.Center)
                        .margin(topBottom = 0.px)
                        .fontFamily(Template4Constants.FONT_FAMILY)
                        .fontSize(18.px)
                        .fontStyle(FontStyle.Italic)
                        .fontWeight(FontWeight.Normal)
                        .toAttrs()
                ) {
                    Text("\"${LocalText(template4Review.review)}\"")

                }
            }

        }

    }
}